import { useEffect } from 'react';

export const useModalBodyScroll = (modalOpen) => {
  useEffect(() => {
    if (modalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [modalOpen]);
};
